import { OfferStatus } from '../../../../../modules/privateOffer/reducer'
import type { ChannelPartnerPrivateOffer } from '../../../../../modules/channelPartnerPrivateOffer/reducer'

export type ChannelOfferHeaderActionsProps = {
  channelPrivateOffer: ChannelPartnerPrivateOffer
  crmOpportunityId?: string
  resaleAuthorizationId?: string
}

export const getDeleteOfferDisabledTooltip = (
  offer?: ChannelPartnerPrivateOffer | null,
  canWriteMarketplace?: boolean
): string => {
  if (!offer) return ''

  if (offer.draft) {
    return 'Draft offers can be deleted.'
  }

  switch (offer.offerStatus) {
    case OfferStatus.PRIVATE_OFFER_EMAIL_SENT:
      return 'Sent offer cannot be deleted.'
    case OfferStatus.PRIVATE_OFFER_CREATION_IN_PROGRESS:
      return 'In progress offer cannot be deleted.'
    case OfferStatus.OFFER_ACCEPTED:
      return 'Accepted offer cannot be deleted.'
    case OfferStatus.PRIVATE_OFFER_VIEWED:
      return 'Viewed offer cannot be deleted.'
    case OfferStatus.OFFER_RESTRICTED:
      return 'Cancelled offer cannot be deleted.'
    default:
      return 'This offer cannot be deleted in its current status.'
  }
}
